(function () {
  var params = new URLSearchParams(window.location.search);
  if (!params.has('allegiance_promo')) return;

  var requested = (params.get('allegiance_promo') || '').trim().toLowerCase();
  var off = requested === '' || requested === '0' || requested === 'false' || requested === 'off';
  var next = off ? '' : requested;

  var current = (window.theme && theme.cartPreviewAttribute) || '';
  if (current === next) return;

  fetch(theme.routes.cartUpdate, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { _gwp_preview: next } })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Could not set preview mode');
      params.delete('allegiance_promo');
      var query = params.toString();
      window.location.replace(
        window.location.pathname + (query ? '?' + query : '') + window.location.hash
      );
    })
    .catch(function () {});
})();

(function () {
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-cart-goals-size]');
    if (sizeBtn) {
      var sizeCard = sizeBtn.closest('[data-cart-goals-reward]');
      if (!sizeCard) return;
      sizeCard.querySelectorAll('[data-cart-goals-size]').forEach(function (btn) {
        var selected = btn === sizeBtn;
        btn.classList.toggle('cart-goals-reward__size--selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      sizeCard.dataset.variantId = sizeBtn.dataset.variantId;
      var clearError = sizeCard.querySelector('.cart-goals-reward__error');
      if (clearError) clearError.textContent = '';
      return;
    }

    var addBtn = e.target.closest('[data-cart-goals-add]');
    if (!addBtn) return;

    var card = addBtn.closest('[data-cart-goals-reward]');
    if (!card || card.classList.contains('cart-goals-reward--loading')) return;

    var errorEl = card.querySelector('.cart-goals-reward__error');
    if (errorEl) errorEl.textContent = '';

    var variantId = parseInt(card.dataset.variantId, 10);
    if (!variantId) {
      if (errorEl) errorEl.textContent = 'Please select a size.';
      return;
    }

    card.classList.add('cart-goals-reward--loading');

    // Tags the gift line so each campaign's rewards are identifiable in the order.
    var item = { id: variantId, quantity: 1 };
    var gwpValue = card.dataset.gwpValue;
    if (gwpValue) item.properties = { _gwp: gwpValue };

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not add gift to cart');
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
      })
      .catch(function () {
        card.classList.remove('cart-goals-reward--loading');
        if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
      });
  });
})();

(function () {
  // Clear gifts the cart no longer qualifies for.
  //
  // The discount Function prices lines; it cannot add or remove them. So when a
  // shopper drops below a threshold (or an offer is paused mid-session) the gift
  // stays in the cart at full price and they would be charged for it. Liquid
  // works out which line keys are disqualified and publishes them on
  // [data-cart-gwp-remove]; this removes them and refreshes the drawer.
  //
  // That element carries data-merge-attributes, so theme.mergeNodes rewrites the
  // attribute on every cart change. We watch the attribute itself rather than
  // guessing at a delay after 'on:cart:change' — the merge happens asynchronously
  // and a timer would race it.
  //
  // Removing a gift never changes the qualifying total (gift lines are excluded
  // from it), so one pass always settles.
  var inFlight = {};

  function removeDisqualifiedGifts(el) {
    var keys = (el.getAttribute('data-cart-gwp-remove') || '')
      .split(',')
      .map(function (k) { return k.trim(); })
      .filter(Boolean);

    // Forget keys that have dropped off the list, so a gift that is re-added and
    // later disqualified again is still removed.
    Object.keys(inFlight).forEach(function (k) {
      if (keys.indexOf(k) === -1) delete inFlight[k];
    });

    var todo = keys.filter(function (k) { return !inFlight[k]; });
    if (!todo.length) return;
    todo.forEach(function (k) { inFlight[k] = true; });

    // Sequential, not parallel: each /cart/change.js returns the whole cart, and
    // concurrent writes to it clobber one another.
    todo
      .reduce(function (chain, key) {
        return chain.then(function () {
          return fetch(theme.routes.cartChange, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      }, Promise.resolve())
      .then(function () {
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
      })
      .catch(function () {
        // Leave the cart alone on failure. The gift stays visible rather than
        // silently vanishing, and the next cart change tries again.
        todo.forEach(function (k) { delete inFlight[k]; });
      });
  }

  function watch() {
    var el = document.querySelector('[data-cart-gwp-remove]');
    if (!el) return;
    removeDisqualifiedGifts(el);
    new MutationObserver(function () {
      removeDisqualifiedGifts(el);
    }).observe(el, { attributes: true, attributeFilter: ['data-cart-gwp-remove'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
